import { render, staticRenderFns } from "./CertificationsList.vue?vue&type=template&id=30681314"
import script from "./CertificationsList.vue?vue&type=script&lang=js"
export * from "./CertificationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports